// ** UI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// ** Components
import Section from '@/components/common/Section';
import VideoBlock from './VideoBlock';

// ** Types
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksVideoBlock as BlocksVideoBlockProps } from '@/types/graphql';

type ComponentBlocksVideoBlockProps = StrapiComponentProps<BlocksVideoBlockProps>;

const ComponentBlocksVideoBlock = ({
	containerSx,
	videoContent,
	videoSectionTitle
}: ComponentBlocksVideoBlockProps) => {
	return (
		<Section containerSx={containerSx}>
			{/* 1. Standard Section Title */}
			{videoSectionTitle && (
				<Typography
					variant="title-lg"
					component="h2"
					sx={{
						mb: 6,
						color: 'common.black',
						fontSize: { xs: '2rem', md: '2.5rem' },
						lineHeight: { xs: '2.5rem', md: '3rem' },
						letterSpacing: { xs: '-0.64px', md: '-1.2px' }
					}}
				>
					{videoSectionTitle}
				</Typography>
			)}

			{/* 2. Map Video Content to V2 Design */}
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
				{videoContent?.map((item, index) => {
					if (!item?.videoData) return null;

					const { video, link, videoTitle, videoDescription } = item.videoData;

					// Determine Source: Use Strapi File URL or External Link
					const src = video?.url || link || '';

					if (!src) return null;

					return (
						<VideoBlock
							key={item.videoData.videoTitle || index}
							src={src}
							title={videoTitle || undefined}
							description={videoDescription || undefined}
						/>
					);
				})}
			</Box>
		</Section>
	);
};

export default ComponentBlocksVideoBlock;
